import { useSelector } from 'react-redux';
import { selectDoesUserHaveRbacPermission } from 'core/userContext/selectors';
import { ProjectPermission } from 'modules/domains/project';

export const useHasProjectPermission = (permission: ProjectPermission) =>
  useSelector(selectDoesUserHaveRbacPermission)(permission);
